module.exports = __webpack_public_path__ + "static/img/noComment.0282cddb.png";